export const elementsContainer = 'search-booking-element';
export const modalContainer = '.modal-placeholder';
